import React from 'react';
import { Button } from 'react-bootstrap';
import { confirmAlert } from 'react-confirm-alert'; 
import 'react-confirm-alert/src/react-confirm-alert.css';

const confirmDeletePPT = (id, file, deleteFile, delHeader) => {
  confirmAlert({
    customUI: ({ onClose }) => {
      return (
        <div className='confirm-delete-modal'>
          <h3>{delHeader}</h3>
          <Button
          variant="primary"
            onClick={() => {
              deleteFile(id, file)
              onClose();
            }}
          >
            Yes
          </Button>
          <Button variant="default" onClick={onClose}>No</Button>
        </div>
      );
    }
  });
};

export default confirmDeletePPT;